import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { Button, Select, MenuItem, TextField, IconButton } from '@material-ui/core'

import {
  getEnsambladoras,
  getSedes,
  addSedeToEmpresa,
  postSede,
  deleteSede
} from '@auteco/services/sostenibilidadService'
import DeleteIcon from '@material-ui/icons/Delete'

const SedesSostenibilidadContainer = () => {
  const [empresas, setEmpresas] = useState([])
  const [sedes, setSedes] = useState([])
  const [selectedEmpresa, setSelectedEmpresa] = useState('')
  const [selectedSede, setSelectedSede] = useState('')
  const [newSedeName, setNewSedeName] = useState('')

  const columns = [
    { title: 'Id', field: 'id' },
    { title: 'Nombre', field: 'nombre' },
    { title: 'Activo', field: 'activo', type: 'boolean' },
    { title: 'Fecha de Creación', field: 'creacion', type: 'datetime' },
  ]

 

  const handleGetEmpresas = async () => {
    const response = await getEnsambladoras()
    if (response && response.ensambladoras) {
      setEmpresas(response.ensambladoras)
    }
  }

  const handleGetSedes = async () => {
    const response = await getSedes()
    if (response && response.sedes) {
      setSedes(response.sedes)
    }
  }

  const handleDeleteSede = async (id) => {
    const response = await deleteSede(id)
    if (response.data.success) {
      alert('Sede eliminada correctamente')
    } else {
      alert('No se pudo eliminar la sede')
    }
    await handleGetSedes()

  }

  const handleAddSede = async () => {
    if (selectedEmpresa && selectedSede) {
      const response = await addSedeToEmpresa(selectedEmpresa, selectedSede)
      if (response) {
       await handleGetEmpresas() // Refresh empresas data
        setSelectedEmpresa('')
        setSelectedSede('')
      }
    }
  }

  const handleCreateSede = async () => {
    if (newSedeName.trim()) {
      const response = await postSede({ nombre: newSedeName.trim() })
      if (response) {
        await handleGetSedes() // Refresh sedes data
        setNewSedeName('')
      }
    }
  }

  useEffect(() => {
    handleGetSedes()
    handleGetEmpresas()
  }, [])

  return (
    <div>
      <h2>Sedes</h2>
      <MaterialTable
        title="Sedes Registradas"
        columns={[
          { title: 'ID', field: 'id' },
          { title: 'Nombre', field: 'nombre' },
          { title: 'Activo', field: 'activo', type: 'boolean' },
          {
            title: 'Eliminar',
            field: 'eliminar',
            render: (rowData) => (
              <IconButton onClick={() => handleDeleteSede(rowData.id)}>
                <DeleteIcon />
              </IconButton>
            ),
          },

        ]}
        data={sedes}
        options={{
          headerStyle: {
            backgroundColor: '#f1f1f1',
            color: 'black',
            fontWeight: 'bold',
          },
        }}
      />

      <div style={{ marginTop: '30px', marginBottom: '50px' }}>
        <TextField
          label="Nombre de nueva sede"
          value={newSedeName}
          onChange={(e) => setNewSedeName(e.target.value)}
          style={{ marginRight: '10px' }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateSede}
          disabled={!newSedeName.trim()}
        >
          Crear Nueva Sede
        </Button>
      </div>

      <MaterialTable
        title="Ensambladoras"
        columns={columns}
        data={empresas}
        detailPanel={[
          {
            tooltip: 'Ver Sedes',
            render: (rowData) => (
              <MaterialTable
                title={`Sedes de ${rowData.nombre}`}
                columns={[
                  { title: 'ID', field: 'id' },
                  { title: 'Nombre', field: 'nombre' },
                ]}
                data={rowData.sedes}
                options={{
                  search: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#f1f1f1',
                    color: 'black',
                    fontWeight: 'bold',
                  },
                }}
              />
            ),
          },
        ]}
        options={{
          headerStyle: {
            backgroundColor: '#f1f1f1',
            color: 'black',
            fontWeight: 'bold',
          },
        }}
      />

      <div style={{ marginTop: '20px' }}>
        <h3>Agregar Sede a Ensambladora</h3>
        <Select
          value={selectedEmpresa}
          onChange={(e) => setSelectedEmpresa(e.target.value)}
          displayEmpty
          style={{ marginRight: '10px' }}
        >
          <MenuItem value="" disabled>
            Seleccionar Empresa
          </MenuItem>
          {empresas.map((empresa) => (
            <MenuItem key={empresa.id} value={empresa.id}>
              {empresa.nombre}
            </MenuItem>
          ))}
        </Select>
        <Select
          value={selectedSede}
          onChange={(e) => setSelectedSede(e.target.value)}
          displayEmpty
          style={{ marginRight: '10px' }}
        >
          <MenuItem value="" disabled>
            Seleccionar Sede
          </MenuItem>
          {sedes
            .filter(
              (sede) =>
                !empresas.find(
                  (empresa) =>
                    empresa.id === selectedEmpresa &&
                    empresa.sedes.some((s) => s.id === sede.id),
                ),
            )
            .map((sede) => (
              <MenuItem key={sede.id} value={sede.id}>
                {sede.nombre}
              </MenuItem>
            ))}
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddSede}
          disabled={!selectedEmpresa || !selectedSede}
        >
          Agregar
        </Button>
      </div>
    </div>
  )
}

export default SedesSostenibilidadContainer
